import { FormConfig } from '../models/form-config';
import { isArray } from '../../core/utils/utils';

export class SubmitValidateFormService {

  constructor(private controls: any,
              private formConfig: FormConfig,
              private errorsMap: Map<string, string[]>) {

  }

  public validateField(fieldKey: string) {
    Object.keys(this.controls).forEach((key) => {
      this.controls[key].markAsTouched();
    });

    this._fillErrorsMapWithAngularErrors(fieldKey);
    this.showErrors();
  }

  public markAsTouchFields() {
    Object.keys(this.controls).forEach((key) => {
      this.controls[key].markAsTouched();
    });
  }

  public fillErrorMap() {
    Object.keys(this.controls).forEach((key) => {
      this._fillErrorsMapWithAngularErrors(key);
    });
  }

  public showErrors() {
    this.errorsMap.forEach((value: string[], key: string) => {
      this._showError(key, this._prepareErrorsArray(value, key, this.formConfig.formKey));
    });
  }

  private _prepareErrorsArray(errors: string[], key: string, formKey: string): any[] {
    const array = [];
    errors.forEach(error => {
      array.push({ [error]: formKey + '.' + key + '.' + error });
    });
    return array.pop();
  }

  private _showError(fieldKey, error: any[]) {
    const control = this.controls[fieldKey];
    if (control !== undefined) {
      control.setErrors(error);
      control.markAsTouched();
    }
  }

  private _fillErrorsMapWithAngularErrors(fieldKey) {
    const field = this.controls[fieldKey];
    if (field !== undefined) {
      const err: any = field.errors;
      if (err !== null && err !== undefined) {
        let errors = [];
        if (!isArray(err)) {
          errors = Object.getOwnPropertyNames(err);
        } else {
          if (typeof err[0] === 'string') {
            errors.push(err[0]);
          } else {
            errors = Object.getOwnPropertyNames(err[0]);
          }
        }
        errors.forEach(error => {
          const errorsToShow = [];
          if (error !== undefined) {
            errorsToShow.push(error);
          }
          this.errorsMap.set(fieldKey, errorsToShow);
        });
      } else {
        if (this.errorsMap.has(fieldKey)) {
          this.errorsMap.delete(fieldKey)
        };
      }
    }
  }
}
